<template>
  <tr class="cabinet__tbody-row">
    <td class="cabinet__tbody-column cabinet__tbody-column--unit">
      {{ item.id }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--purchase-name">
      {{ item.fullName }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--purchase-name">
      {{ item.email }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--number">
      {{ roles }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--nmc">
      {{ item.status }}
    </td>
    <td class="cabinet__tbody-column cabinet__tbody-column--tooltip">
      <CommonModal :item="item" />
    </td>
  </tr>
</template>

<script>
import { getRolesString } from '@/utils/helpers';
import CommonModal from '@/components/popup/CommonModal.vue';

export default {
  name: 'OrganizationsTableItem',
  components: { CommonModal },
  props: {
    item: {
      type: Object,
    },
  },
  computed: {
    roles() {
      return getRolesString(this.item?.roles);
    },
  },
  methods: {
    openModal() {
      // eslint-disable-next-line no-alert
      alert('Редактировать');
    },
  },
};
</script>

<style lang="scss" scoped>
.actions-container {
  display: flex;
  gap: 8px;
}

.action-item {
  height: 22px;
  width: 22px;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
  appearance: none;
  border: 0;
  background-color: transparent;
}
</style>
